function NotFound() {
  return <section className="not-found">
    <h1>404</h1>
    <p>Requested page not found</p>
    <p>please check address or navigate with menu</p>
  </section>
}

export default NotFound